var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"mb-6"},[_c('v-btn',{attrs:{"text":"","to":{ name: 'Produits', query: { ..._vm.$route.query } }}},[_c('v-icon',[_vm._v("mdi-arrow-left")]),_vm._v(" "+_vm._s(_vm.$t("boutique.retourALaListeDesProduits")))],1)],1),_c('Produit',{attrs:{"id":_vm.id}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }